var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"maps-point"},[_c('div',{staticClass:"begin w-full"},[_c('gmaps-map',{attrs:{"options":{ center: { lat: parseFloat(_vm.pointLocation.lat), lng: parseFloat(_vm.pointLocation.lng) }, zoom: 12 }}},[_c('gmaps-marker',{attrs:{"position":{ lat: parseFloat(_vm.pointLocation.lat), lng: parseFloat(_vm.pointLocation.lng) }}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }